export default {
    meta: {
        title: '刊例价管理',
        isShowNav: true,
    },
};
